// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "lead_consent_event".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "lead_consent_event" table (1:1 with a DB row, on the wire). */
export const leadConsentEventAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    leadId: z.string(),
    channel: z.string(),
    consentType: z.string(),
    action: z.string(),
    disclosureText: z.string().nullable(),
    sourceUrl: z.string().nullable(),
    source: z.string().nullable(),
    contactValue: z.string().nullable(),
    ipAddress: z.string().nullable(),
    userAgent: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=leadConsentEvent.js.map